import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Button, Input} from 'antd'

@inject('store') @observer
class LiveTrade extends Component {
  state = {password: ''}
  handleOk = () => {
    const {paperTrading} = this.props.store
    const algoId = this.props.algo.id
    const {password} = this.state
    paperTrading.turnOn({type: 'live', algoId, redirect: true, password})
  }
  handleChange = (e) => {
    const {value} = e.target
    this.setState({password: value})
  }
  render() {
    const {turningOn} = this.props.store.paperTrading
    return(
      <Modal
        title='Please enter password to verify it is you'
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
        footer={[
          <Button key="back" onClick={this.props.close}>Cancel</Button>,
          <Button key="submit" type="primary" loading={turningOn} onClick={this.handleOk}>
            Turn Live Trading On
          </Button>
        ]}
        destroyOnClose
      >
        <Input
          type='password'
          onChange={this.handleChange}
          value={this.state.password}
          placeholder='Password'
          size='large'
        />
      </Modal>
    )
  }
}

export default LiveTrade
